// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39jnl","buttons":"styles_buttons__1GP7P"};